import { Button, Modal, Option, Select, selectClasses } from "@mui/joy"
import { BASE_URL, BLACK, PRIMARY, STATUS } from "../../appConstants"
import { canEdit, formatDateTime, getDateString } from "../../appFunctions"
import { UUID } from "crypto"
import React, { Dispatch, SetStateAction, useState } from "react"
import EditOneTimeSchedule from "./EditOneTimeSchedule"



interface AccountInfo {
    marketplaceStringId: string;
    id: string;
    type: string;
    name: string;
    validPaymentMethod: boolean;
}

interface ProfileObject {
    profileId: number;
    countryCode: string;
    currencyCode: string;
    dailyBudget: number;
    timezone: string;
    accountInfo: AccountInfo;
}

type FileDetailObj = {
    file_detail_id: UUID,
    start_date: string,
    end_date: string,
    schedule_date: string,
    schedule_time: string,
    series_id: string,
    weekday: number,
    days: number[],
    schedule_status: string,
    schedule_name: string,
    file_id: string,
    emails: string,
    created_by: UUID,
    updated_by: UUID,
    created_time_stamp: string,
    updated_time_stamp: string,
    file_name: string,
    brand_id: string,
    status: string,
    type: string,
    recurring_type: string,
    time_slots: string[],
    profile_obj: ProfileObject

}
type ConfirmObj = {
    fileDetail: FileDetailObj, action: string
}

const ViewOneTimeScheduleModal: React.FC<{ fetchBulkFileDetail: () => void, viewSchedule: FileDetailObj, closeViewHandler: () => void, setConfirmObj: Dispatch<SetStateAction<ConfirmObj>> }> = ({ fetchBulkFileDetail, viewSchedule, closeViewHandler, setConfirmObj }) => {




    const [show, setShow] = useState("VIEW");

    const statusMap = new Map<string, string>([
        ["ACTIVE", "Active"],
        ["PAUSED", "Paused"],
        ["CANCELLED", "Cancelled"]
    ]);


    const statusColorMap = new Map<string, string>([
        ["ACTIVE", STATUS.S_Green],
        ["PAUSED", "#EB730A"],
        ["CANCELLED", STATUS.S_Red]
    ]);


    const statusBackgroundColorMap = new Map<string, string>([
        ["ACTIVE", STATUS.S_Green10],
        ["PAUSED", "#FFF2C7"],
        ["CANCELLED", STATUS.S_Red10]
    ]);

    const scheduleStatusMap = new Map<string, string>([
        ["SUCCESSFUL", "Successful"],
        ["UPCOMING", "Upcoming"],
        ["FAILED", "Failed"],
        ["PARTIAL_SUCCESSFUL", "Partial Successful"]
    ])
    const scheduleStatusColorMap = new Map<string, string>([
        ["SUCCESSFUL", STATUS.S_Green],
        ["UPCOMING", PRIMARY.P_BLue],
        ["FAILED", STATUS.S_Red],
        ["PARTIAL_SUCCESSFUL", "#EB730A"]
    ])


    const onActionClickHandler = (event: any, value: any) => {


        if (value === "EDIT_DETAILS") {
            setShow("EDIT");
            return;
        }


        setConfirmObj({
            fileDetail: viewSchedule,
            action: value
        })

        closeViewHandler();
    }

    const { type, status } = viewSchedule;

    return (
        <Modal
            open={true}
            sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
            className="h-full"
        >
            <div
                style={{ width: 790 }}
                className="flex flex-col border rounded-lg px-10 py-10 bg-white"
            >
                {
                    show === "VIEW" && (
                        <>
                            <div className="flex justify-between " style={{ height: 40 }}  >
                                <div className="flex"  >
                                    <div style={{ fontSize: 16, fontWeight: 600, lineHeight: "24px" }} >
                                        Sponsored Ads Bulk File
                                    </div>
                                    <div className="px-2 py-1 w-fit ml-2" style={{ height: 24, color: statusColorMap.get(viewSchedule?.status), backgroundColor: statusBackgroundColorMap.get(viewSchedule?.status), borderRadius: 4, fontSize: 10, fontWeight: 500 }} >
                                        {
                                            statusMap.get(viewSchedule?.status)
                                        }
                                    </div>
                                </div>
                                {
                                    canEdit(viewSchedule?.schedule_date, viewSchedule?.schedule_time) && status != "CANCELLED" && (
                                        <Select
                                            // value={brand_power_bi_dashboard_id}
                                            onChange={onActionClickHandler}
                                            placeholder="Actions"
                                            indicator={<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g id="Iconography">
                                                    <path id="Vector" d="M13.354 6.35354L8.35403 11.3535C8.30759 11.4 8.25245 11.4369 8.19175 11.4621C8.13105 11.4872 8.06599 11.5002 8.00028 11.5002C7.93457 11.5002 7.86951 11.4872 7.80881 11.4621C7.74811 11.4369 7.69296 11.4 7.64653 11.3535L2.64653 6.35354C2.55271 6.25972 2.5 6.13247 2.5 5.99979C2.5 5.86711 2.55271 5.73986 2.64653 5.64604C2.74035 5.55222 2.8676 5.49951 3.00028 5.49951C3.13296 5.49951 3.26021 5.55222 3.35403 5.64604L8.00028 10.2929L12.6465 5.64604C12.693 5.59958 12.7481 5.56273 12.8088 5.53759C12.8695 5.51245 12.9346 5.49951 13.0003 5.49951C13.066 5.49951 13.131 5.51245 13.1917 5.53759C13.2524 5.56273 13.3076 5.59958 13.354 5.64604C13.4005 5.69249 13.4373 5.74764 13.4625 5.80834C13.4876 5.86904 13.5006 5.93409 13.5006 5.99979C13.5006 6.06549 13.4876 6.13054 13.4625 6.19124C13.4373 6.25193 13.4005 6.30708 13.354 6.35354Z" fill="#1886FE" />
                                                </g>
                                            </svg>}

                                            sx={{
                                                height: "40px",
                                                marginLeft: "16px",
                                                minWidth: 160,
                                                color: "#1886FE", borderRadius: 8, borderColor: "#1886FE",
                                                [`& .${selectClasses.indicator}`]: {
                                                    transition: '0.2s',
                                                    [`&.${selectClasses.expanded}`]: {
                                                        transform: 'rotate(-180deg)',
                                                    },
                                                },
                                            }}
                                        >
                                            {/* {
                                [{ name: "Pause", id: "PAUSED" }, { name: "Cancel", id: "CANCEL" }, { name: "Edit Details", id: "EDIT_DETAILS" }]?.map(el => {
                                    return <Option value={el?.id}  >{el?.name}</Option>
                                })
                            } */}

                                            {
                                                (() => {
                                                    if (type === "one_time") {
                                                        if (status === "ACTIVE") {
                                                            return (
                                                                <>
                                                                    <Option value={"CANCELLED"}  >Cancel</Option>
                                                                </>
                                                            )
                                                        }
                                                    }
                                                    // else if (type === "recurring") {
                                                    //     if (status === "ACTIVE") {
                                                    //         return (
                                                    //             <>
                                                    //                 <MenuItem onClick={() => updateFileDetail(fileDetail, "PAUSED", false)} >Pause</MenuItem>
                                                    //                 <MenuItem onClick={() => updateFileDetail(fileDetail, "CANCELLED", false)} >Cancel</MenuItem>
                                                    //             </>
                                                    //         )
                                                    //     } else if (status === "PAUSED") {
                                                    //         return (
                                                    //             <>
                                                    //                 <MenuItem onClick={() => updateFileDetail(fileDetail, "ACTIVE", true)} >Active</MenuItem>
                                                    //                 <MenuItem onClick={() => updateFileDetail(fileDetail, "CANCELLED", false)} >Cancel</MenuItem>
                                                    //             </>
                                                    //         )
                                                    //     }
                                                    // }
                                                })()
                                            }
                                            {
                                                canEdit(viewSchedule?.schedule_date, viewSchedule?.schedule_time) && <Option value={"EDIT_DETAILS"}  >Edit Details</Option>
                                            }

                                        </Select>
                                    )
                                }

                            </div>

                            <div className="flex items-center mt-6 px-6 justify-between" style={{ height: 66, backgroundColor: PRIMARY.P_Light, borderRadius: 8 }} >
                                <div className="flex">
                                    <div className="mr-2" >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path d="M19.4998 26C19.4998 26.2652 19.3945 26.5196 19.2069 26.7071C19.0194 26.8946 18.765 27 18.4998 27H14.9998C14.7346 27 14.4802 26.8946 14.2927 26.7071C14.1052 26.5196 13.9998 26.2652 13.9998 26V19C13.9998 18.7348 14.1052 18.4804 14.2927 18.2929C14.4802 18.1054 14.7346 18 14.9998 18C15.265 18 15.5194 18.1054 15.7069 18.2929C15.8945 18.4804 15.9998 18.7348 15.9998 19V25H18.4998C18.765 25 19.0194 25.1054 19.2069 25.2929C19.3945 25.4804 19.4998 25.7348 19.4998 26ZM11.5811 18.1863C11.4742 18.1099 11.3534 18.0554 11.2254 18.0258C11.0975 17.9961 10.965 17.992 10.8354 18.0136C10.7059 18.0352 10.5819 18.0821 10.4704 18.1516C10.359 18.2211 10.2624 18.3119 10.1861 18.4188L8.49982 20.78L6.81357 18.4188C6.73996 18.3055 6.64416 18.2083 6.53196 18.1331C6.41977 18.0579 6.29349 18.0062 6.16076 17.9811C6.02803 17.956 5.89159 17.9581 5.75968 17.9872C5.62778 18.0163 5.50313 18.0718 5.39327 18.1504C5.28341 18.229 5.19061 18.329 5.12047 18.4445C5.05033 18.5599 5.00431 18.6884 4.98518 18.8221C4.96605 18.9558 4.97421 19.092 5.00916 19.2225C5.04412 19.353 5.10515 19.475 5.18857 19.5812L7.27107 22.5L5.18607 25.4188C5.04575 25.6346 4.99412 25.8963 5.04192 26.1494C5.08973 26.4024 5.23329 26.6272 5.44271 26.777C5.65213 26.9268 5.91126 26.9901 6.16616 26.9536C6.42105 26.9172 6.65205 26.7838 6.81107 26.5812L8.49982 24.22L10.1861 26.5812C10.3451 26.7838 10.5761 26.9172 10.831 26.9536C11.0859 26.9901 11.345 26.9268 11.5544 26.777C11.7638 26.6272 11.9074 26.4024 11.9552 26.1494C12.003 25.8963 11.9514 25.6346 11.8111 25.4188L9.72857 22.5L11.8136 19.5812C11.8899 19.4744 11.9444 19.3535 11.9741 19.2256C12.0037 19.0977 12.0078 18.9651 11.9862 18.8356C11.9646 18.7061 11.9178 18.582 11.8482 18.4706C11.7787 18.3592 11.6879 18.2626 11.5811 18.1863ZM23.9486 21.4137C23.4486 21.2687 22.9311 21.12 22.6423 20.9338C22.4861 20.8312 22.4886 20.8088 22.5023 20.6963C22.5042 20.6054 22.5279 20.5162 22.5714 20.4364C22.6149 20.3566 22.6769 20.2883 22.7523 20.2375C23.3273 19.8475 24.6698 20.0225 25.2298 20.1675C25.4864 20.235 25.7593 20.1977 25.9884 20.064C26.2176 19.9303 26.3842 19.711 26.4517 19.4544C26.5192 19.1978 26.4819 18.9249 26.3482 18.6957C26.2145 18.4666 25.9952 18.3 25.7386 18.2325C25.4748 18.1637 23.1136 17.58 21.6348 18.5775C21.323 18.7882 21.0612 19.0647 20.8679 19.3876C20.6746 19.7105 20.5545 20.0719 20.5161 20.4463C20.2661 22.4313 22.2223 22.9975 23.3911 23.335C24.8986 23.7712 25.0311 23.95 24.9886 24.2838C24.9498 24.585 24.8311 24.7 24.7198 24.775C24.1448 25.1575 22.8248 24.9688 22.2773 24.8188C22.0212 24.7476 21.7474 24.7812 21.516 24.912C21.4014 24.9768 21.3007 25.0635 21.2197 25.1671C21.1386 25.2708 21.0788 25.3894 21.0436 25.5163C21.0084 25.6431 20.9985 25.7756 21.0145 25.9062C21.0305 26.0368 21.072 26.163 21.1368 26.2776C21.2676 26.509 21.485 26.6789 21.7411 26.75C22.3609 26.9133 22.9989 26.9973 23.6398 27C24.3673 27 25.1773 26.875 25.8261 26.4425C26.1461 26.2297 26.415 25.9485 26.6134 25.6194C26.8118 25.2902 26.9348 24.9211 26.9736 24.5387C27.2498 22.375 25.1848 21.7712 23.9486 21.4137ZM4.99982 14V5C4.99982 4.46957 5.21053 3.96086 5.5856 3.58579C5.96068 3.21071 6.46938 3 6.99982 3H18.9998C19.1312 2.9999 19.2613 3.02568 19.3827 3.07586C19.5041 3.12605 19.6144 3.19967 19.7073 3.2925L26.7073 10.2925C26.8002 10.3854 26.8738 10.4958 26.924 10.6172C26.9741 10.7385 26.9999 10.8686 26.9998 11V14C26.9998 14.2652 26.8945 14.5196 26.7069 14.7071C26.5194 14.8946 26.265 15 25.9998 15C25.7346 15 25.4802 14.8946 25.2927 14.7071C25.1052 14.5196 24.9998 14.2652 24.9998 14V12H18.9998C18.7346 12 18.4802 11.8946 18.2927 11.7071C18.1052 11.5196 17.9998 11.2652 17.9998 11V5H6.99982V14C6.99982 14.2652 6.89446 14.5196 6.70692 14.7071C6.51939 14.8946 6.26503 15 5.99982 15C5.7346 15 5.48025 14.8946 5.29271 14.7071C5.10517 14.5196 4.99982 14.2652 4.99982 14ZM19.9998 10H23.5848L19.9998 6.41375V10Z" fill="#1C1C1C" />
                                        </svg>
                                    </div>
                                    <div className="flex  flex-col" >
                                        <div className="mb-1" style={{ fontSize: 12, fontWeight: 500, color: BLACK.B_100 }} >{viewSchedule?.file_name}</div>
                                        <div style={{ fontSize: 10, fontWeight: 500, color: BLACK.B_40 }} className="flex items-center" > {formatDateTime(viewSchedule?.created_time_stamp)[0]} <svg className="mx-2" xmlns="http://www.w3.org/2000/svg" width="4" height="4" viewBox="0 0 4 4" fill="none">
                                            <circle cx="2" cy="2" r="2" fill="#B8B8B8" />
                                        </svg>  {formatDateTime(viewSchedule?.created_time_stamp)[1]}
                                        </div>
                                    </div>
                                </div>

                                <a href={`${BASE_URL}brand/bulk/downloadFile/${viewSchedule?.file_id}`}   >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M21 14.25V19.5C21 19.8978 20.842 20.2794 20.5607 20.5607C20.2794 20.842 19.8978 21 19.5 21H4.5C4.10218 21 3.72064 20.842 3.43934 20.5607C3.15804 20.2794 3 19.8978 3 19.5V14.25C3 14.0511 3.07902 13.8603 3.21967 13.7197C3.36032 13.579 3.55109 13.5 3.75 13.5C3.94891 13.5 4.13968 13.579 4.28033 13.7197C4.42098 13.8603 4.5 14.0511 4.5 14.25V19.5H19.5V14.25C19.5 14.0511 19.579 13.8603 19.7197 13.7197C19.8603 13.579 20.0511 13.5 20.25 13.5C20.4489 13.5 20.6397 13.579 20.7803 13.7197C20.921 13.8603 21 14.0511 21 14.25ZM11.4694 14.7806C11.539 14.8504 11.6217 14.9057 11.7128 14.9434C11.8038 14.9812 11.9014 15.0006 12 15.0006C12.0986 15.0006 12.1962 14.9812 12.2872 14.9434C12.3783 14.9057 12.461 14.8504 12.5306 14.7806L16.2806 11.0306C16.3503 10.9609 16.4056 10.8782 16.4433 10.7872C16.481 10.6961 16.5004 10.5985 16.5004 10.5C16.5004 10.4015 16.481 10.3039 16.4433 10.2128C16.4056 10.1218 16.3503 10.0391 16.2806 9.96937C16.2109 9.89969 16.1282 9.84442 16.0372 9.8067C15.9461 9.76899 15.8485 9.74958 15.75 9.74958C15.6515 9.74958 15.5539 9.76899 15.4628 9.8067C15.3718 9.84442 15.2891 9.89969 15.2194 9.96937L12.75 12.4397V3.75C12.75 3.55109 12.671 3.36032 12.5303 3.21967C12.3897 3.07902 12.1989 3 12 3C11.8011 3 11.6103 3.07902 11.4697 3.21967C11.329 3.36032 11.25 3.55109 11.25 3.75V12.4397L8.78063 9.96937C8.63989 9.82864 8.44902 9.74958 8.25 9.74958C8.05098 9.74958 7.86011 9.82864 7.71937 9.96937C7.57864 10.1101 7.49958 10.301 7.49958 10.5C7.49958 10.699 7.57864 10.8899 7.71937 11.0306L11.4694 14.7806Z" fill="#1C1C1C" />
                                    </svg>
                                </a>

                            </div>

                            <div className="mt-4 p-6" style={{ border: `1px solid ${BLACK.B_5}`, borderRadius: 8 }}>
                                <div className="flex justify-between" >
                                    <div style={{ height: 44, width: 210 }}>
                                        <div style={{ fontSize: 12, fontWeight: 500, lineHeight: "18px", color: BLACK.B_40 }} >Type</div>
                                        <div style={{ fontSize: 14, fontWeight: 700, lineHeight: "20px", color: BLACK.B_100 }} >One Type</div>
                                    </div>
                                    <div style={{ height: 44, width: 210 }}>
                                        <div style={{ fontSize: 12, fontWeight: 500, lineHeight: "18px", color: BLACK.B_40 }} >Start Date</div>
                                        <div style={{ fontSize: 14, fontWeight: 700, lineHeight: "20px", color: BLACK.B_100 }} >{formatDateTime(viewSchedule?.start_date)[0]}</div>
                                    </div>
                                    <div style={{ height: 44, width: 210 }}>
                                        <div style={{ fontSize: 12, fontWeight: 500, lineHeight: "18px", color: BLACK.B_40 }} >Upcoming Schedule</div>
                                        <div style={{ fontSize: 14, fontWeight: 700, lineHeight: "20px", color: BLACK.B_100 }} >{formatDateTime(viewSchedule?.start_date)[0]} {viewSchedule?.schedule_time?.split(":")[0]}:{viewSchedule?.schedule_time?.split(":")[1]}</div>
                                    </div>
                                </div>
                                <div className="flex justify-between mt-6" >
                                    <div style={{ height: 44, width: 210 }}>
                                        <div style={{ fontSize: 12, fontWeight: 500, lineHeight: "18px", color: BLACK.B_40 }} >Last Schedule</div>
                                        <div style={{ fontSize: 14, fontWeight: 700, lineHeight: "20px", color: BLACK.B_100 }} >-</div>
                                    </div>
                                    <div style={{ height: 44, width: 210 }}>
                                        <div style={{ fontSize: 12, fontWeight: 500, lineHeight: "18px", color: BLACK.B_40 }} >Schedule Status</div>
                                        <div style={{ fontSize: 14, fontWeight: 700, lineHeight: "20px", color: BLACK.B_100 }} >

                                            <div className="" style={{ color: scheduleStatusColorMap.get(viewSchedule?.schedule_status), fontSize: 14, fontWeight: 700, lineHeight: "20pxs" }} >
                                                {
                                                    scheduleStatusMap.get(viewSchedule?.schedule_status)
                                                }
                                            </div>

                                        </div>
                                    </div>
                                    <div style={{ height: 44, width: 210 }}>

                                    </div>
                                </div>
                            </div>

                            <div className="flex flex-row justify-between mt-10">
                                <Button color="neutral"
                                    sx={{
                                        height: "48px",
                                        width: "340px",
                                        backgroundColor: BLACK.B_5,
                                        color: BLACK.B_100,
                                        ":hover": {
                                            backgroundColor: BLACK.B_20,
                                        }
                                    }}
                                    onClick={closeViewHandler}
                                >Cancel</Button>
                                <Button
                                    onClick={closeViewHandler}
                                    // endDecorator={
                                    //     <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                                    //         <path d="M17.8172 10.4425L12.1922 16.0675C12.0749 16.1848 11.9159 16.2507 11.75 16.2507C11.5841 16.2507 11.4251 16.1848 11.3078 16.0675C11.1905 15.9503 11.1247 15.7912 11.1247 15.6253C11.1247 15.4595 11.1905 15.3004 11.3078 15.1832L15.8664 10.6253H3.625C3.45924 10.6253 3.30027 10.5595 3.18306 10.4423C3.06585 10.3251 3 10.1661 3 10.0003C3 9.83459 3.06585 9.67562 3.18306 9.55841C3.30027 9.4412 3.45924 9.37535 3.625 9.37535H15.8664L11.3078 4.81753C11.1905 4.70026 11.1247 4.5412 11.1247 4.37535C11.1247 4.2095 11.1905 4.05044 11.3078 3.93316C11.4251 3.81588 11.5841 3.75 11.75 3.75C11.9159 3.75 12.0749 3.81588 12.1922 3.93316L17.8172 9.55816C17.8753 9.61621 17.9214 9.68514 17.9529 9.76101C17.9843 9.83688 18.0005 9.91821 18.0005 10.0003C18.0005 10.0825 17.9843 10.1638 17.9529 10.2397C17.9214 10.3156 17.8753 10.3845 17.8172 10.4425Z" fill="white" />
                                    //     </svg>
                                    // }
                                    sx={{
                                        height: "48px",
                                        width: "340px",
                                        backgroundColor: PRIMARY.P_BLue,
                                    }}
                                >Done</Button>
                            </div>
                        </>
                    )

                }
                {
                    show === "EDIT" && <EditOneTimeSchedule fetchBulkFileDetail={fetchBulkFileDetail} closeViewHandler={closeViewHandler} fileDetail={viewSchedule} />
                }
            </div>

        </Modal>
    )
}

export default ViewOneTimeScheduleModal;